var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({staticClass:"p-number-input",attrs:{"type":"number"},on:{"keydown":_vm.onKeydown},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }